import { Flex } from '@chakra-ui/react';
import { FC } from 'react';

import { CircleLoader } from '@/components/ui/core/CircleLoader/CircleLoader';

interface INoTicketLoaderProps {}

export const NoTicketLoader: FC<INoTicketLoaderProps> = () => {
  return (
    <Flex alignItems="center" justifyContent="center" minH={'calc(100vh - 4.5rem)'}>
      <CircleLoader color="gray.200" />
    </Flex>
  );
};
